import {
  CorrespondentServiceClient,
  Correspondent,
} from '../proto/accountpb/correspondent_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import { Empty } from '../google/protobuf/empty_pb';

export async function getSiteDetails(param) {
  return new Promise((resolve, reject) => {
    const req = new Correspondent();
    const service = new CorrespondentServiceClient(window.env.GRPC_ENDPOINT);
    service.getSiteDetails(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getCorrespondentByUrl() {
  return new Promise((resolve, reject) => {
    let req = new Empty();
    const service = new CorrespondentServiceClient(
      window.env.GRPC_ENDPOINT,
      {},
      { ...auth }
    );
    service.getCorrespondentByUrl(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
